<template>
  <div class="app-layout" :class="{ 'no-sidebar': isAuthPage }">
    <!-- Mobile Header -->
    <header v-if="!isAuthPage" class="mobile-header glass-panel">
      <div class="mobile-header-content">
        <button @click="sidebarOpen = !sidebarOpen" class="hamburger-btn">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </button>
        <h2 class="mobile-title">Telegram Admin</h2>
      </div>
    </header>

    <div v-if="sidebarOpen" class="sidebar-overlay" @click="sidebarOpen = false"></div>

    <AppSidebar v-if="!isAuthPage" :is-open="sidebarOpen" @close="sidebarOpen = false" />
    
    <main class="main-content" :style="isAuthPage ? 'margin-left: 0; padding: 0;' : ''">
      <router-view/>
    </main>
  </div>
</template>

<script>
import AppSidebar from './components/Sidebar.vue'

export default {
  name: 'App',
  components: {
    AppSidebar
  },
  data() {
    return {
      sidebarOpen: false
    }
  },
  computed: {
    isAuthPage() {
      return this.$route.path === '/login';
    }
  },
  watch: {
    $route() {
      // route o'zgarganda sidebarni yopish
      if(window.innerWidth <= 768) {
        this.sidebarOpen = false;
      }
    }
  }
}
</script>

<style>
/* Global transition for router */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Mobile Header Styles */
.mobile-header {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  z-index: 40;
  border-radius: 0;
  border-bottom: 1px solid var(--glass-border);
}

.mobile-header-content {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 1rem;
  gap: 1rem;
}

.hamburger-btn {
  background: transparent;
  border: none;
  color: var(--text-main);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  border-radius: 8px;
}

.hamburger-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.mobile-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
  background: linear-gradient(to right, #fff, #94a3b8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.sidebar-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 45;
}

@media (max-width: 768px) {
  .mobile-header {
    display: block;
  }
  .sidebar-overlay {
    display: block;
  }
}
</style>
